import { LevelOrder } from "../ars_ldm";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is a LevelOrder.
 *
 * @param obj - The value to check
 * @returns True if the value is a LevelOrder
 */
export const isLevelOrder = (obj: unknown): obj is LevelOrder => {
  // Check object
  if (!isObjectRecord(obj)) return false;
  // Check properties exist
  const chkObj = obj as LevelOrder;
  if (typeof chkObj.level !== "number") return false;
  if (typeof chkObj.order !== "number") return false;
  // Everything is good
  return true;
};
